import { useEffect, useState } from "react";
import init from '@v2/components/common/yotpo/widgets/init';
import { ErrorMessagePage } from "@v2/components/ui/ErrorBoundary";

export default function Yoalty({ widgetID }: { widgetID: string }) {
    const [error, setError] = useState(false);

    useEffect(() => {
        setError(init);
    }, []);

    return (
        <>
            {!error
                ?
                <div className="yotpo-widget-instance" data-yotpo-instance-id={widgetID}></div>
                :
                <ErrorMessagePage
                    heading={`Yoalty program could not load`}
                    message={'Yoalty program is not available at this moment please try again later.'}
                />
            }
        </>
    );
}